module.exports = __webpack_public_path__ + "static/media/shieldRoundOpen.4f0da402.jpg";